import axios from 'axios'

const FONT_BASE_URL = 'https://fonts.googleapis.com/css'
const PREVIEW_ATTRIBUTE_NAME = 'data-is-preview'

const getFontUrl = (font, previewOnly) => {
  const url = new URL(FONT_BASE_URL)

  // If previewsOnly: Only query the characters contained in the font names
  if (previewOnly) {
    url.searchParams.append('family', font)
    const downloadChars = font
      .split('')
      .filter((char, pos, self) => self.indexOf(char) === pos)
      .join('')
    // Query only the identified characters
    url.searchParams.append('text', downloadChars)
  }
  const fontFamilyWeights = font.concat(':400,700')
  url.searchParams.append('family', fontFamilyWeights)
  // Tell browser to render fallback font immediately and swap in the new font once it's loaded
  url.searchParams.append('font-display', 'swap')

  return url
}

const getLinkId = (font) => {
  return `font-${font}`
}

// Check whether a font link tag already exists in the document head
const linkTagExists = (font, isPreview) => {
  const linkNode = document.getElementById(getLinkId(font))
  return (
    linkNode !== null &&
    linkNode.getAttribute(PREVIEW_ATTRIBUTE_NAME) === isPreview
  )
}

export const createLinkTag = (font, previewOnly) => {
  const previewAttribute = previewOnly?.toString() || ''
  if (!linkTagExists(font, previewAttribute)) {
    const linkUrl = getFontUrl(font, previewOnly)
    const linkNode = document.createElement('link')
    linkNode.id = getLinkId(font)
    linkNode.setAttribute(PREVIEW_ATTRIBUTE_NAME, previewAttribute)
    linkNode.setAttribute('rel', 'stylesheet')
    linkNode.setAttribute('href', linkUrl)
    document.head.appendChild(linkNode)
  }
}

export const getFontList = () => {
  axios
    .get(
      `https://www.googleapis.com/webfonts/v1/webfonts?key=${process.env.GOOGLE_FONTS_KEY}&sort=popularity`
    )
    .then(function (response) {
      // handle success
      return response.data.items
    })
    .catch(function (error) {
      // handle error
      console.log(error)
    })
}
